import React from 'react';

const AccessDenied: React.FC<{}> = () => {
  return (
    <div className="access-denied-container">
      <h2>Access Denied</h2>
      <p>
        Please request for access to AcarsHistory{' '}
        <a
          href="https://www.alaskasworld.com/HelpDesk/AccountAccessForms/NewAccountReq.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        {' '}
        .
      </p>
    </div>
  );
};

export default AccessDenied;
